import { render, staticRenderFns } from "./Pinball.vue?vue&type=template&id=523e1d86&scoped=true&"
import script from "./Pinball.vue?vue&type=script&lang=ts&"
export * from "./Pinball.vue?vue&type=script&lang=ts&"
import style0 from "./Pinball.vue?vue&type=style&index=0&id=523e1d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e1d86",
  null
  
)

export default component.exports